import script from "./leads-details.vue?vue&type=script&setup=true&lang=js"
export * from "./leads-details.vue?vue&type=script&setup=true&lang=js"

import "./leads-details.vue?vue&type=style&index=0&id=6d02cc1f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d02cc1f"]])

export default __exports__